import { useEffect } from "react"

export const useScrollOnRender = () => {
	useEffect(() => {
		if (window.location.hash) {
			const hash = window.location.hash;

			try {
				const element = document.querySelector(hash);
				if (element) {
					element.scrollIntoView({ behavior: 'smooth' });
				}
			} catch (e) {
				console.warn('Invalid hash selector:', hash, e);
			}
		}
	}, [])
}
